import React, { useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate, useNavigationType, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useAuth0 } from "@auth0/auth0-react";

import usePermissions from "hooks/usePermissions";
import useToken from "hooks/useToken";
import { clearFiltersFromLocalStorage } from "helpers/localStorage";
import Button from "components/atoms/Button/Button";
import { unsubscribeFromPushManager } from "helpers/notificationHelpers";

interface ErrorPageProps {
  clearError: () => void;
}

function ErrorPage({ clearError }: ErrorPageProps) {
  const navigate = useNavigate();
  const type = useNavigationType();
  const location = useLocation();
  const intl = useIntl();
  const { logout, isAuthenticated } = useAuth0();
  const { token, clearToken } = useToken();
  const { permissions, clearPermissions } = usePermissions();
  const prevLocation = useRef(location.pathname);

  useEffect(() => {
    // Check if the location has actually changed
    if (prevLocation.current !== location.pathname) {
      clearError();
      prevLocation.current = location.pathname;
    }
  }, [location.pathname, clearError]);

  const handleRedirect = () => {
    if (!permissions && !token && isAuthenticated) {
      unsubscribeFromPushManager();
      clearToken();
      clearPermissions();
      clearFiltersFromLocalStorage();
      Cookies.remove("auth0_id_token");
      Cookies.remove("cargobase_logged_in_as_token");
      Cookies.remove("cargobase_usertoken");
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    } else if (type === "PUSH") {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <Row>
      <Col md={12}>
        <h1 className="mb-4">
          <FormattedMessage id="errorPage.someThingWentWrong" defaultMessage="Something went wrong." />
        </h1>
        <p>
          <FormattedMessage
            id="errorPage.description"
            defaultMessage="Sorry, something went wrong there. Please try again or refresh the page."
          />
        </p>
        <Button
          label={intl.formatMessage({
            id: "general.back",
            defaultMessage: "Back",
          })}
          className="mt-4"
          onClick={handleRedirect}
        />
      </Col>
    </Row>
  );
}

export default ErrorPage;
